import Tickets from "./list.tickets";

export default Tickets;